import { RedemptionService } from "../core/redemption-service";


export class DevRedemptionService extends RedemptionService
{
    
    getBaseUrl = ()=> `https://dev.best-experiences.com/withlogin-universal-redemptions/api`;

    
} 
